import { render, staticRenderFns } from "./NewDocumentForm.vue?vue&type=template&id=45e9f03a&scoped=true&"
import script from "./NewDocumentForm.vue?vue&type=script&lang=ts&"
export * from "./NewDocumentForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewDocumentForm.vue?vue&type=style&index=0&id=45e9f03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e9f03a",
  null
  
)

export default component.exports